import { render, staticRenderFns } from "./RentalCustomerInfo.vue?vue&type=template&id=008a5138&"
import script from "./RentalCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./RentalCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports